import React, {useContext, useEffect} from 'react'
import {Form} from 'react-bootstrap'
import {withTranslation} from 'react-i18next'
import Spinner from 'react-bootstrap/Spinner'
import {Tabs, Tab} from 'react-bootstrap'
import CustomMultiSelectFieldForAssign from '../CustomComponents/CustomMultiSelectFieldForAssign'
import {AuditModalApiContext} from '../../../../context/AuditModalApi'
import {AssignAuditContext} from '../../../../context/Modal/AssignAudit'
import {AuditModalBarContext} from '../../../../context/AuditModalBar'
import {AuditPaneContext} from '../../../../context/AuditPane'
import {UserContext} from '../../../../context/User'
import {AuditDetailsContext} from '../../../../context/Modal/AuditDetails'

function AssignAuditForm(props) {
  const {
    individual_audit,
    audit_users_attributes,
    audit_email_users_attributes,
    audit_user_templates_attributes,
    selected_templates_users,
    editAssignUser,

    setIndividualAudit,
    setAuditUsersAttributes,
    setAuditEmailUsersAttributes,
    setAuditUserTemplatesAttributes,
    setSelectedTemplatesUsers,
    setEditAssignUser,
  } = useContext(AssignAuditContext)

  const {users, userTemplates, getUsers, getUserTemplates, updateSearchUsers} = useContext(
    AuditModalApiContext
  )
  const current_user = useContext(UserContext)
  const modalBar = React.useContext(AuditModalBarContext)
  const paneState = React.useContext(AuditPaneContext)
  const {status} = React.useContext(AuditDetailsContext)
  const disabled = status === 'incomplete' && paneState.modalType === 'edit' ? true : false

  let usersError
  if (modalBar.errors.length > 0) {
    modalBar.errors.map(err => {
      switch (err.error_field) {
        case 'name':
          usersError = err
          break
        default:
          break
      }
      return true
    })
  }

  useEffect(() => {
    if (users.users.length === 0) {
      if (current_user.details.is_admin) {
        getUserTemplates()
      }
      getUsers()
    }
    if (audit_users_attributes.length === 0 && editAssignUser) {
      let defaultSelected = [
        {
          user_name: current_user.details.full_name,
          user_id: current_user.details.id,
        },
      ]
      setAuditUsersAttributes(defaultSelected)
      setAuditEmailUsersAttributes(defaultSelected)
      setEditAssignUser(false)
    }
    //eslint-disable-next-line
  }, [getUsers, getUserTemplates, users.users.length, current_user.details.is_admin])

  const removeDuplicates = (myArr, prop) => {
    return myArr.filter((obj, pos, arr) => {
      return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos
    })
  }

  const getUserArray = (e, userCheck) => {
    let newArr = []
    newArr = e.map(item => {
      if (item.value !== '') {
        return {
          user_id: item.value,
          user_name: item.label,
        }
      }
      return true
    })

    if (userCheck) {
      audit_user_templates_attributes.map((template, index) => {
        let removeStatus = false
        var templateIndex = userTemplates.templates
          .map(function(e) {
            return e.template_id
          })
          .indexOf(template.template_id)

        userTemplates?.templates[templateIndex]?.template_users.length > 0 &&
          userTemplates.templates[templateIndex].template_users.map(template_user => {
            if (!newArr.some(el => el.user_id === template_user.id)) {
              removeStatus = true
            }
            return true
          })

        if (removeStatus) {
          audit_user_templates_attributes.splice(index, 1)
        }
        return true
      })
    }
    return newArr
  }

  const getUserTemplateArray = e => {
    console.log(e)
    let newArr = []
    let templateUsers = []
    let currentUsers =
      selected_templates_users &&
      audit_users_attributes.filter(function(obj) {
        return selected_templates_users.indexOf(obj) === -1
      })
    newArr = e.map(item => {
      if (item.value !== '') {
        let index = userTemplates.templates
          .map(function(e) {
            return e.template_id
          })
          .indexOf(item.value)
        userTemplates?.templates[index]?.template_users.length > 0 &&
          userTemplates.templates[index].template_users.map(template_user => {
            templateUsers.push({
              user_id: template_user.id,
              user_name: template_user.name,
            })
            return true
          })
        selected_templates_users &&
          selected_templates_users.map(selected_user => {
            templateUsers.push({
              user_id: selected_user.user_id,
              user_name: selected_user.user_name,
            })
            return true
          })
        return {
          template_id: item.value,
          template_name: item.label,
          template_rule_id: item.value,
        }
      }
      return true
    })

    currentUsers = currentUsers.concat(templateUsers)
    currentUsers = removeDuplicates(currentUsers, 'user_id')
    setSelectedTemplatesUsers(templateUsers)
    updateSearchUsers(templateUsers)
    setAuditUsersAttributes(currentUsers)
    return newArr
  }

  const getOptionItem = (values, selectedValues) => {
    let options = []
    let selectedOptions = []
    if (values.length > 0) {
      options = values.map(u => {
        return {
          label: u.first_name + ' ' + u.last_name,
          value: u.id,
        }
      })
      selectedOptions = selectedValues.map(u => {
        return {
          label: u.user_name,
          value: u.user_id,
        }
      })
    }
    options.sort(function(a, b) {
      var textA = a.label.toUpperCase()
      var textB = b.label.toUpperCase()
      return textA < textB ? -1 : textA > textB ? 1 : 0
    })

    options.unshift({
      label: current_user.details.full_name + ' (myself)',
      value: current_user.details.id,
    })

    options = removeDuplicates([...options, ...selectedOptions], 'value')

    if (options.length > 0) {
      options.unshift({label: 'Select All', value: 'select_all'})
    }
    return options
  }

  const getUserTemplateOptionItem = (values, selectedValues) => {
    let options = []
    let selectedOptions = []
    if (values.length > 0) {
      options = values.map(t => {
        return {
          label: t.template_name,
          value: t.template_id,
        }
      })
      console.log(selectedValues)
      selectedOptions = selectedValues.map(t => {
        return {
          label: t.template_name,
          value: t.template_id,
        }
      })

      options.sort(function(a, b) {
        var textA = a.label.toUpperCase()
        var textB = b.label.toUpperCase()
        return textA < textB ? -1 : textA > textB ? 1 : 0
      })

      options = removeDuplicates([...options, ...selectedOptions], 'value')

      if (options.length > 0) {
        options.unshift({label: 'Select All', value: 'select_all'})
      }
    }
    return options
  }

  const handleUsersAttributes = e => {
    setAuditUsersAttributes(getUserArray(e, true))
  }

  const handleEmailUsersAttributes = e => {
    setAuditEmailUsersAttributes(getUserArray(e, false))
  }

  const handleUserTemplatesAttributes = e => {
    setAuditUserTemplatesAttributes(getUserTemplateArray(e))
  }

  return (
    <div>
      <form
        className={
          status === 'incomplete' && disabled
            ? 'audit-forms form-data width-100-persent not-allowed'
            : 'audit-forms form-data width-100-persent'
        }
      >
        <div className="row">
          <div className="col-7">
            <Form.Check
              type="switch"
              id="customSwitches"
              className="ap-toggle"
              label=""
              onChange={() => setIndividualAudit(!individual_audit)}
              checked={individual_audit}
              disabled={disabled}
            />
            <h5 className="gray-color">Individual Audit</h5>
            <p className="borderBottom pb-2 mb-1 small gray-color">
              Each user has to finish their part of the audit.
            </p>
          </div>
          <hr></hr>
          <p className="col-7 mt-2 small gray-color">
            If Individual Audit is enabled, each user will see restricted audit list based on their
            user permissions. The audit will be finished when all users finish their portion of the
            audit.
          </p>
        </div>
        <div id="assign-audit" className="mt-15">
          <Tabs defaultActiveKey="users" unmountOnExit={true}>
            <Tab eventKey="users" title="Assign Users" className="mt-3 assign_users">
              {users.isLoading ? (
                <Spinner animation="border" role="status" />
              ) : (
                <>
                  <span></span>
                  <CustomMultiSelectFieldForAssign
                    assignFor="user"
                    menuIsOpen={true}
                    optionItems={getOptionItem(users.users, audit_users_attributes)}
                    value={audit_users_attributes}
                    handleChange={e => handleUsersAttributes(e)}
                  />
                </>
              )}
              {usersError && <div className="text-danger">{usersError.error_message}</div>}
            </Tab>
            {current_user.details.is_admin && (
              <Tab eventKey="template" title="Assign Templates" className="mt-3 assign_users">
                {userTemplates.isLoading ? (
                  <Spinner animation="border" role="status" />
                ) : (
                  <>
                    <span></span>
                    <CustomMultiSelectFieldForAssign
                      assignFor="template"
                      menuIsOpen={true}
                      optionItems={getUserTemplateOptionItem(
                        userTemplates.templates,
                        audit_user_templates_attributes
                      )}
                      value={audit_user_templates_attributes}
                      handleChange={e => handleUserTemplatesAttributes(e)}
                    />
                  </>
                )}
                {usersError && <div className="text-danger">{usersError.error_message}</div>}
              </Tab>
            )}
            <Tab eventKey="emails" title="Assign Emails" className="mt-3 assign_users">
              {users.isLoading ? (
                <Spinner animation="border" role="status" />
              ) : (
                <>
                  <span></span>
                  <CustomMultiSelectFieldForAssign
                    assignFor="userTemplate"
                    menuIsOpen={true}
                    optionItems={getOptionItem(users.userEmails, audit_email_users_attributes)}
                    value={audit_email_users_attributes}
                    handleChange={e => handleEmailUsersAttributes(e)}
                  />
                </>
              )}
              {usersError && <div className="text-danger">{usersError.error_message}</div>}
            </Tab>
          </Tabs>
        </div>
      </form>
    </div>
  )
}

export default withTranslation()(AssignAuditForm)
